import {
  SortAscendingIcon,
  SortDescendingIcon,
  SwitchVerticalIcon,
} from 'kfone-component-library/svgIcons';

interface ISortableHeaderProps<T = string> {
  label: React.ReactNode;
  columnKey: T;
  currentSortColumn: T | null;
  currentSortDirection: 'asc' | 'desc' | null;
  onSort: (columnKey: T) => void;
  testId?: string;
  className?: string;
}

export const SortableHeader = <T extends string>({
  label,
  columnKey,
  currentSortColumn,
  currentSortDirection,
  onSort,
  testId,
}: ISortableHeaderProps<T>) => {
  const isSortedColumn = currentSortColumn === columnKey;
  const resolvedDirection: 'asc' | 'desc' | null = isSortedColumn
    ? currentSortDirection === 'desc'
      ? 'desc'
      : 'asc'
    : null;

  return (
    <div className='flex items-center gap-1.5'>
      <span className='text-center'>{label}</span>
      <button
        type='button'
        className='ods-component ods-button default tertiary sort-icon-button h-auto w-auto min-w-0 flex-shrink-0 p-0'
        data-testid={testId}
        onClick={() => onSort(columnKey)}
      >
        {resolvedDirection === 'asc' ? (
          <SortAscendingIcon className='sort-icon' />
        ) : resolvedDirection === 'desc' ? (
          <SortDescendingIcon className='sort-icon' />
        ) : (
          <SwitchVerticalIcon className='sort-icon' />
        )}
      </button>
    </div>
  );
};
export default SortableHeader;
